import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon, ShieldCheckIcon, ZapIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { PremiumUpsellCTA, CHECKOUT_KIT } from './PremiumUpsellCTA';
const includes = ['Mindfulness — Kit Antiestrés para el Trabajo', 'Kit Práctico de Conversaciones Difíciles', '100 Respuestas para Situaciones Difíciles', 'Ejercicios Prácticos para Mejorar el Ambiente Laboral', '⭐ PREMIUM: Neurociencia — cómo responde tu cerebro al estrés laboral', '⭐ PREMIUM: El Umbral del Descanso — técnicas nocturnas para desconectar', 'Más de 60 páginas', 'Descarga digital', 'Acceso de por vida', 'Acceso desde cualquier dispositivo'];
export function OfferSection() {
  return <section id="oferta" className="w-full py-20 md:py-28 px-4" data-id="element-173" data-mp="wawvhu227xwr">
      <div className="max-w-3xl mx-auto" data-id="element-174" data-mp="2t6kwy4ow04r8">
        {/* Offer card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-white border border-rose/30 rounded-3xl p-7 md:p-10 shadow-2xl shadow-rose/10" data-id="element-175" data-mp="2y3ul7h0jiadh">
          <div className="text-center mb-6" data-id="element-176" data-mp="oxeyrgivlmel">
            <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-3 py-1 rounded-full mb-4" data-id="element-177" data-mp="1lme34kgca41i">
              <span className="text-[11px] font-bold tracking-widest" data-id="element-178" data-mp="1gnje30rs3j8y">
                ⭐ OFERTA ESPECIAL
              </span>
            </div>
            <div className="flex justify-center mb-5" data-id="element-179" data-mp="1ck4uy18jmmra">
              <img src="https://cdn.magicpatterns.com/uploads/vvwFq218QqEK4oqinbrNgQ/imagen_principal.png" alt="Kit Antiestrés para el Trabajo — 4 materiales digitales" className="h-44 md:h-56 w-auto object-contain drop-shadow-xl" data-id="element-180" data-mp="17mv6ooww4h51" />
            </div>
            <h2 className="font-serif font-bold text-3xl md:text-4xl text-ink uppercase tracking-tight leading-tight" data-id="element-181" data-mp="3ttq0kgxclzge">
              Kit Antiestrés{' '}
              <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-182" data-mp="2llvld940skr">
                para el Trabajo
              </span>
            </h2>
            <p className="font-serif-italic text-rose text-lg mt-2" data-id="element-183" data-mp="3otv9oddkp9vc">
              4 materiales + 2 materiales premium · +60 páginas
            </p>
          </div>

          {/* Price */}
          <div className="text-center mb-7" data-id="element-184" data-mp="3fuhz1hdpqf91">
            <div className="text-muted mb-2 text-[14px]" data-id="element-185" data-mp="3fvjdlvtxtjvi">
              Valor individual: <span className="line-through" data-id="element-186" data-mp="316n2tr0hxsr7">$39.990</span>
            </div>
            <div className="flex items-baseline justify-center gap-2 flex-wrap" data-id="element-187" data-mp="363ncsd0gvfnl">
              <span className="font-serif font-bold text-5xl md:text-6xl text-rose" data-id="element-188" data-mp="2s4w2z2sn0g59">
                $19.990
              </span>
              <span className="text-lg text-ink-soft" data-id="element-189" data-mp="2x2p5nluqes0s">ARS</span>
            </div>
            <div className="inline-flex items-center gap-2 bg-rose text-white text-xs font-black px-3 py-1 rounded-full mt-3" data-id="element-190" data-mp="2dhf91tgiyba6">
              50% OFF
            </div>
            <div className="text-sm text-muted mt-2" data-id="element-191" data-mp="28l6x0oxmiy78">
              Pago único · Acceso de por vida
            </div>
          </div>

          {/* Includes */}
          <div className="bg-bg-warm border border-line rounded-2xl p-5 md:p-6 mb-7" data-id="element-192" data-mp="2ig8hv8kv9e40">
            <div className="text-xs font-bold text-rose tracking-widest mb-4 text-center" data-id="element-193" data-mp="2wfrilgbcln6a">
              INCLUYE TODO ESTO
            </div>
            <ul className="space-y-2.5" data-id="element-194" data-mp="2rflu290dkgsf">
              {includes.map((it, i) => <li key={i} className="flex items-start gap-3 text-sm" data-id="element-195" data-mp="365t4c1g8ati1" data-mpi={i}>
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-rose/15 flex items-center justify-center mt-0.5" data-id="element-196" data-mp="318kow8mgt3kh">
                    <CheckIcon className="w-3 h-3 text-rose" strokeWidth={3} data-id="element-197" data-mp="3f7k8h1v4es9s" />
                  </span>
                  <span className="text-ink" data-id="element-198" data-mp="3aa0tu0uigdhb">{it}</span>
                </li>)}
            </ul>
          </div>

          <a href={CHECKOUT_KIT} target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout');
          }
        }} className="flex items-center justify-center gap-2 w-full bg-rose hover:bg-rose-deep text-white font-bold text-lg md:text-xl py-5 rounded-full text-center shadow-xl shadow-rose/30 hover:-translate-y-0.5 transition-all" data-id="element-199" data-mp="1di4zrn8u5bkq">
            <ArrowRightIcon className="w-5 h-5" data-id="element-200" data-mp="yk2qqxj1bxw3" />
            QUIERO MI KIT ANTIESTRÉS
          </a>

          <PremiumUpsellCTA data-id="element-201" data-mp="13lifp0oc2ojr" />

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-6 text-xs text-muted" data-id="element-202" data-mp="13hktu7adfiw6">
            <span className="flex items-center gap-1.5" data-id="element-203" data-mp="2ez40yar2o600">
              <LockIcon className="w-3.5 h-3.5 text-rose" data-id="element-204" data-mp="2exj9iu02136d" /> Pago seguro
            </span>
            <span className="text-line" data-id="element-205" data-mp="2p1px1t50o11b">|</span>
            <span className="flex items-center gap-1.5" data-id="element-206" data-mp="2k3y2ssgwg2ty">
              <ZapIcon className="w-3.5 h-3.5 text-rose" data-id="element-207" data-mp="2k4homk9o7bd9" /> Acceso en 5 min
            </span>
            <span className="text-line" data-id="element-208" data-mp="2fbwufhmuqw97">|</span>
            <span className="flex items-center gap-1.5" data-id="element-209" data-mp="2bbmebc5cipgm">
              <ShieldCheckIcon className="w-3.5 h-3.5 text-rose" data-id="element-210" data-mp="2bb4l6odzcrcx" /> Garantía 7
              días
            </span>
            <span className="text-line" data-id="element-211" data-mp="26agkfazy8w5i">|</span>
            <span className="flex items-center gap-1.5" data-id="element-212" data-mp="21d6za7jlf6nh">
              <CreditCardIcon className="w-3.5 h-3.5 text-rose" data-id="element-213" data-mp="21fjbs56l0ot5" /> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}